// HKDSE Type D (詩歌) Quiz Data
// 系統化分類測驗數據，為後續 Supabase 後端數據遷移做準備

const hkdseTypeDQuizData = {
  // D1: 范仲淹《岳陽樓記》
  'hkdse-d1-fanzhongyan-yueyanglou-ji': {
    keyPoints: {
      title: '重點概念',
      questions: [
        {
          id: 'd1-kp-1',
          question: '《將進酒》的核心主題是什麼？',
          options: [
            'A. 及時行樂',
            'B. 人生苦短，及時行樂',
            'C. 懷才不遇的憤慨',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '詩歌表達了人生苦短、及時行樂的思想，同時也抒發了懷才不遇的憤慨。',
          points: 10
        },
        {
          id: 'd1-kp-2',
          question: '詩中「天生我材必有用」表達了什麼？',
          options: [
            'A. 自負自大',
            'B. 自信樂觀',
            'C. 無奈自嘲',
            'D. 憤世嫉俗'
          ],
          correctAnswer: 'B',
          explanation: '這句話表達了李白對自己才華的自信和樂觀的人生態度。',
          points: 10
        },
        {
          id: 'd1-kp-3',
          question: '「千金散盡還復來」體現了什麼人生態度？',
          options: [
            'A. 揮霍無度',
            'B. 豪放不羈',
            'C. 樂觀豁達',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '這句話體現了李白豪放不羈、樂觀豁達的人生態度。',
          points: 10
        }
      ]
    },
    argumentationMethods: {
      title: '論證手法',
      questions: [
        {
          id: 'd1-am-1',
          question: '詩歌如何論證「及時行樂」？',
          options: [
            'A. 通過對比',
            'B. 通過比喻',
            'C. 通過舉例',
            'D. 通過反證'
          ],
          correctAnswer: 'A',
          explanation: '詩歌通過對比人生短暫與及時行樂的重要性來論證主題。',
          points: 10
        },
        {
          id: 'd1-am-2',
          question: '李白如何突出人生短暫？',
          options: [
            'A. 直接描述',
            'B. 通過比喻',
            'C. 通過誇張',
            'D. 通過對比'
          ],
          correctAnswer: 'B',
          explanation: '李白通過「朝如青絲暮成雪」等比喻來突出人生短暫。',
          points: 10
        }
      ]
    },
    writingTechniques: {
      title: '寫作手法',
      questions: [
        {
          id: 'd1-wt-1',
          question: '詩歌主要採用什麼體裁？',
          options: [
            'A. 古體詩',
            'B. 近體詩',
            'C. 樂府詩',
            'D. 歌行體'
          ],
          correctAnswer: 'D',
          explanation: '《將進酒》採用歌行體，句式自由，節奏鮮明。',
          points: 10
        },
        {
          id: 'd1-wt-2',
          question: '詩歌的語言特色是什麼？',
          options: [
            'A. 樸實無華',
            'B. 華麗典雅',
            'C. 豪放奔放',
            'D. 含蓄委婉'
          ],
          correctAnswer: 'C',
          explanation: '詩歌語言豪放奔放，體現了李白的浪漫主義風格。',
          points: 10
        }
      ]
    },
    rhetoricalDevices: {
      title: '修辭手法',
      questions: [
        {
          id: 'd1-rd-1',
          question: '「君不見黃河之水天上來」運用了什麼修辭？',
          options: [
            'A. 比喻',
            'B. 誇張',
            'C. 對偶',
            'D. 設問'
          ],
          correctAnswer: 'B',
          explanation: '這句話運用了誇張修辭，突出了黃河之水的氣勢。',
          points: 10
        },
        {
          id: 'd1-rd-2',
          question: '詩中的反問句有什麼作用？',
          options: [
            'A. 增強語氣',
            'B. 突出重點',
            'C. 引發思考',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '反問句既能增強語氣，又能突出重點，還能引發讀者思考。',
          points: 10
        }
      ]
    }
  },

  // D2: 柳宗元《始得西山宴遊記》
  'hkdse-d2-liuzongyuan-xishan-yanyou-ji': {
    keyPoints: {
      title: '重點概念',
      questions: [
        {
          id: 'd2-kp-1',
          question: '《登高》的核心情感是什麼？',
          options: [
            'A. 思鄉之情',
            'B. 憂國憂民',
            'C. 人生感慨',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '詩歌表達了思鄉之情、憂國憂民和人生感慨等多重情感。',
          points: 10
        },
        {
          id: 'd2-kp-2',
          question: '「萬里悲秋常作客」表達了什麼？',
          options: [
            'A. 漂泊之苦',
            'B. 思鄉之情',
            'C. 人生無奈',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '這句話表達了漂泊之苦、思鄉之情和人生無奈。',
          points: 10
        },
        {
          id: 'd2-kp-3',
          question: '詩中「百年多病獨登台」反映了什麼？',
          options: [
            'A. 身體健康',
            'B. 孤獨寂寞',
            'C. 人生艱難',
            'D. 以上皆是'
          ],
          correctAnswer: 'C',
          explanation: '這句話反映了杜甫晚年孤獨寂寞、人生艱難的處境。',
          points: 10
        }
      ]
    },
    argumentationMethods: {
      title: '論證手法',
      questions: [
        {
          id: 'd2-am-1',
          question: '詩歌如何表達憂國憂民？',
          options: [
            'A. 直接抒情',
            'B. 借景抒情',
            'C. 托物言志',
            'D. 以上皆是'
          ],
          correctAnswer: 'B',
          explanation: '詩歌通過描寫登高所見的秋景來表達憂國憂民的情感。',
          points: 10
        },
        {
          id: 'd2-am-2',
          question: '杜甫如何突出孤獨感？',
          options: [
            'A. 直接描述',
            'B. 通過對比',
            'C. 通過環境',
            'D. 通過比喻'
          ],
          correctAnswer: 'C',
          explanation: '杜甫通過描寫蕭瑟的秋景來突出自己的孤獨感。',
          points: 10
        }
      ]
    },
    writingTechniques: {
      title: '寫作手法',
      questions: [
        {
          id: 'd2-wt-1',
          question: '詩歌的結構特點是什麼？',
          options: [
            'A. 起承轉合',
            'B. 並列式',
            'C. 遞進式',
            'D. 對比式'
          ],
          correctAnswer: 'A',
          explanation: '詩歌採用起承轉合的結構，層次分明。',
          points: 10
        },
        {
          id: 'd2-wt-2',
          question: '詩歌的語言特色是什麼？',
          options: [
            'A. 樸實深沉',
            'B. 華麗典雅',
            'C. 豪放奔放',
            'D. 含蓄委婉'
          ],
          correctAnswer: 'A',
          explanation: '詩歌語言樸實深沉，體現了杜甫的現實主義風格。',
          points: 10
        }
      ]
    },
    rhetoricalDevices: {
      title: '修辭手法',
      questions: [
        {
          id: 'd2-rd-1',
          question: '「無邊落木蕭蕭下」運用了什麼修辭？',
          options: [
            'A. 比喻',
            'B. 誇張',
            'C. 對偶',
            'D. 擬聲'
          ],
          correctAnswer: 'D',
          explanation: '「蕭蕭」是擬聲詞，模擬落葉的聲音。',
          points: 10
        },
        {
          id: 'd2-rd-2',
          question: '詩中的對偶有什麼作用？',
          options: [
            'A. 增強節奏',
            'B. 突出對比',
            'C. 深化主題',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '對偶既能增強節奏，又能突出對比，還能深化主題。',
          points: 10
        }
      ]
    }
  },

  // D3: 白居易《琵琶行》
  'hkdse-d3-baijuyi-pipaxing': {
    keyPoints: {
      title: '重點概念',
      questions: [
        {
          id: 'd3-kp-1',
          question: '《琵琶行》的核心主題是什麼？',
          options: [
            'A. 音樂之美',
            'B. 同是天涯淪落人',
            'C. 人生無常',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '詩歌表達了音樂之美、同是天涯淪落人的感慨和人生無常的主題。',
          points: 10
        },
        {
          id: 'd3-kp-2',
          question: '詩中「同是天涯淪落人」表達了什麼？',
          options: [
            'A. 同情憐憫',
            'B. 同病相憐',
            'C. 人生感慨',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '這句話表達了對琵琶女的同情憐憫、同病相憐和人生感慨。',
          points: 10
        },
        {
          id: 'd3-kp-3',
          question: '白居易如何描寫琵琶女的遭遇？',
          options: [
            'A. 直接敘述',
            'B. 通過對比',
            'C. 通過音樂',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '白居易通過直接敘述、對比和音樂等多種手法描寫琵琶女的遭遇。',
          points: 10
        }
      ]
    },
    argumentationMethods: {
      title: '論證手法',
      questions: [
        {
          id: 'd3-am-1',
          question: '詩歌如何論證「同是天涯淪落人」？',
          options: [
            'A. 通過對比',
            'B. 通過舉例',
            'C. 通過比喻',
            'D. 通過反證'
          ],
          correctAnswer: 'A',
          explanation: '詩歌通過對比琵琶女和詩人自己的遭遇來論證主題。',
          points: 10
        },
        {
          id: 'd3-am-2',
          question: '白居易如何突出音樂的感染力？',
          options: [
            'A. 直接描述',
            'B. 通過比喻',
            'C. 通過誇張',
            'D. 通過對比'
          ],
          correctAnswer: 'B',
          explanation: '白居易通過豐富的比喻來突出音樂的感染力。',
          points: 10
        }
      ]
    },
    writingTechniques: {
      title: '寫作手法',
      questions: [
        {
          id: 'd3-wt-1',
          question: '詩歌的敘事特點是什麼？',
          options: [
            'A. 順敘',
            'B. 倒敘',
            'C. 插敘',
            'D. 平敘'
          ],
          correctAnswer: 'A',
          explanation: '詩歌採用順敘手法，按時間順序記述琵琶女的遭遇。',
          points: 10
        },
        {
          id: 'd3-wt-2',
          question: '詩歌的語言特色是什麼？',
          options: [
            'A. 樸實通俗',
            'B. 華麗典雅',
            'C. 豪放奔放',
            'D. 含蓄委婉'
          ],
          correctAnswer: 'A',
          explanation: '詩歌語言樸實通俗，體現了白居易的現實主義風格。',
          points: 10
        }
      ]
    },
    rhetoricalDevices: {
      title: '修辭手法',
      questions: [
        {
          id: 'd3-rd-1',
          question: '「大珠小珠落玉盤」運用了什麼修辭？',
          options: [
            'A. 比喻',
            'B. 誇張',
            'C. 對偶',
            'D. 擬聲'
          ],
          correctAnswer: 'A',
          explanation: '這句話運用了比喻修辭，將琵琶聲比作珠落玉盤。',
          points: 10
        },
        {
          id: 'd3-rd-2',
          question: '詩中的比喻有什麼作用？',
          options: [
            'A. 增強形象性',
            'B. 突出特點',
            'C. 深化主題',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '比喻既能增強形象性，又能突出特點，還能深化主題。',
          points: 10
        }
      ]
    }
  }
};

// Helper functions
export const getTypeDQuizData = () => {
  return hkdseTypeDQuizData;
};

export const getTypeDQuizByType = (textId, categoryType) => {
  const quizData = hkdseTypeDQuizData[textId];
  if (!quizData) return null;

  const categoryData = quizData[categoryType];
  if (!categoryData) return null;

  // Convert questions to match the expected format
  const convertedQuestions = categoryData.questions.map(question => ({
    ...question,
    correct: question.correctAnswer.charCodeAt(0) - 65, // Convert 'A' to 0, 'B' to 1, etc.
    type: 'multiple-choice'
  }));

  return {
    title: categoryData.title,
    questions: convertedQuestions,
    timeLimit: 300, // 5 minutes
    totalPoints: categoryData.questions.reduce((sum, q) => sum + q.points, 0)
  };
};

export default hkdseTypeDQuizData;
